import { render, staticRenderFns } from "./detail-sale-by-product.vue?vue&type=template&id=10c0af6a"
import script from "./detail-sale-by-product.vue?vue&type=script&lang=js"
export * from "./detail-sale-by-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports